export default __webpack_public_path__ + "static/media/heat-5.ff7cc3af.png";